
<template>
    <div class="relative">
        <compFormEdit
            class="margin-layout "
            ref="formbase"
            :formdata="getBase"
            v-model="formData"
            placeholder="--"
            :col="1"
        ></compFormEdit>
        <div class="text-right">
            <vButton theme="primary" @click="submit">{{$t('global.common.operation_submit',{defaultValue:'提交'})}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
        </div>
        <vLoading size="large" fix :loading="loading"></vLoading>
    </div>
</template>

<script>
import { HttpTrackingNoQueryOrgName,HttpSaveUnfreeze,HttpShipManageList } from "@/service/billing";

export default {
    data(){
        return {
            orgName:'',
            formData:{
                organizationId:0,
                organizationName:''
            },
            loading:false,
        }
    },
    computed:{
        getBase(){
            return [
                
                {
                    label: this.$t('fbb.billmanage.bill_no',{defaultValue:'账单编号'}),
                    key: "billNo",
                    on:{
                        'on-blur':(val)=>{
                            let _this = this;
                            HttpShipManageList({'search[EQ_billNo]':val}).then(res=>{
                                let dataone = res.data.content[0].periodCode+'('+res.data.content[0].startTime+' ~ '+res.data.content[0].startTime+')'
                                this.$set(_this.formData,'periodCode',dataone)
                            })
                        }
                    },
                    required:false
                },
                {
                    label: this.$t('erp.b2border.payment_days',{defaultValue:'账期'}),
                    key:'periodCode',
                    query:true
                },
                {
                    label: this.$t('fbb.bill.freeze_trackingno',{defaultValue:'运单号'}),
                    key: "trackingNo",
                    tag:'vInput',
                    on:{
                        'on-blur':(val)=>{
                            // console.log(val)
                            this.getOrgName(val)

                        }
                    }
                }, {
                    label: this.$t('global.common.organization',{defaultValue:'组织'}),
                    valueText:this.formData.organizationName,
                    query:true
                }, {
                    label: this.$t('fbb.bill.delamount',{defaultValue:'扣款金额'}),
                    key: "amount",
                },{
                    label: this.$t('fbb.bill.freeze_open',{defaultValue:'解冻'})+this.$t('global.common.reason',{defaultValue:'原因'}),
                    key: "cause",
                    tag:'vTextarea'
                },
                
            ]
        }
    },
    methods:{
        submit(){
            HttpSaveUnfreeze(this.formData).then(res=>{
                this.$VMessage.success(res.message)
                this.$emit('on-close')
                this.$emit('on-update')
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
        cancel(){
            this.$emit('on-close')
        },
        getOrgName(val){
            this.loading = true;
            HttpTrackingNoQueryOrgName({
                trackingNo:val
            }).then(res=>{
                this.formData.organizationId = res.data.organizationId;
                this.$set(this.formData,'organizationName',res.data.organizationName);
                this.formData.organizationName = res.data.organizationName;
                this.loading = false;
                // this.orgName = res.data
            },err=>{
                this.loading = false;
            })
        }
    }
}
</script>
